import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonView } from './button_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const SignInSupportInformationPreview = ({ productMessages, messages }) => {
    var _a, _b;
    if (!messages) {
        return null;
    }
    return [
        _jsxs("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                backgroundColor: '#f5f4f9',
                height: '100%',
                fontSize: '1.1em',
                lineHeight: '1.2em',
                fontWeight: 500,
                borderRadius: '1em',
            }, children: [_jsxs("div", { style: { padding: '28px 20px 20px' }, children: [_jsx("h1", { style: {
                                marginBottom: 24,
                                display: 'flex',
                                flexDirection: 'column',
                                fontSize: '1.75rem',
                                lineHeight: '2rem',
                                fontWeight: 600,
                            }, children: (_a = productMessages === null || productMessages === void 0 ? void 0 : productMessages.title) !== null && _a !== void 0 ? _a : 'Support information' }), _jsx("div", { style: { color: '#4B5563', fontSize: '0.8em', lineHeight: '1.3em' }, children: (messages === null || messages === void 0 ? void 0 : messages.Support) || '' })] }), _jsx("div", { style: { padding: '0 20px 20px' }, children: _jsx(ButtonView, { label: (_b = productMessages === null || productMessages === void 0 ? void 0 : productMessages.button) !== null && _b !== void 0 ? _b : 'Done' }) })] }, 'sign-in-support-information-root'),
    ];
};
//# sourceMappingURL=sign_in_support_information.preview.component.js.map